import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { PrimaryButton } from "components/Buttons";
import React from "react";

const ContainerPopup = ({
  showConsignmentPopup,
  handleClosePopup,
  submitShipping,
  pendingFormData,
}) => {
  return (
    <>
      <Dialog
        PaperProps={{ sx: { p: 2, width: "500px", borderRadius: "14px" } }}
        open={showConsignmentPopup}
        onClose={handleClosePopup}
      >
        <DialogTitle
          sx={{ fontWeight: 700, fontSize: "22px", color: "#4ab43e" }}
        >
          Consignment Container
        </DialogTitle>

        <DialogContent sx={{ fontWeight: 400, fontSize: "14px" }}>
          All vehicles in this container belong to the same customer. This will
          be declared as a consignment container.
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClosePopup}>Cancel</Button>
          <PrimaryButton
            title={"Proceed"}
            variant="contained"
            onClick={() => {
              handleClosePopup();
              submitShipping(pendingFormData);
            }}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ContainerPopup;
